import { adminRoutes } from 'app/constants/routes';
import { UserRoles } from 'app/constants/user';
import { RouteBuilderItem } from 'app/routes/routeBuilder';

import {
  BrokerAccountMatchingDashboard,
  BrokerAccountMatchingNext,
  BrokerAccountMatchingShow,
} from './BrokerAccountMatchingRouteComponents';

const basePath = adminRoutes.brokerAccountMatchings;

export const brokerAccountMatchingRoutes: RouteBuilderItem[] = [
  /* eslint-disable @typescript-eslint/naming-convention */
  {
    Component: BrokerAccountMatchingDashboard,
    path: `${basePath}/dashboard`,
    permitOnly: [UserRoles.CarrierConnector],
  },
  {
    Component: BrokerAccountMatchingNext,
    path: `${basePath}/next`,
    permitOnly: [UserRoles.CarrierConnector],
  },
  {
    Component: BrokerAccountMatchingShow,
    path: `${basePath}/:id`,
    permitOnly: [UserRoles.CarrierConnector],
  },
  /* eslint-enable @typescript-eslint/naming-convention */
];
